import React, {Component} from "react";

// Assets
import Logo from "../../Assets/Logo.svg";

export default class Introduction extends Component {
  render() {
    return (
      <div className="Home_Introduction">
        <div className="Home_LogoBlock">
          <img src={Logo} className="Home_MCLogo" />
          <div className="Home_MCName">Mellitus Care</div>
        </div>
        <div className="Home_IntroTitle">
          We help you to keep a track on your blood glucose
        </div>
        <div className="Home_IntroDesc">
          Due to imbalance in life style and improper diet people suffers
          diabetes. To overcome this issue we have brought mellitus care which
          helps your to keep track on your blood glucose also by suggesting you
          for a healthy diet.
        </div>
        <button className="Home_GetStartBtn">Get Started</button>
      </div>
    );
  }
}
